import { Component } from 'react';
import PropTypes from 'prop-types';
import Scheduler from 'infrastructure/js/components/Scheduler/schedulerDynamicImport';
import Overlay from 'infrastructure/js/components/Overlay/overlay';
import SchedulerOperationsView from './SchedulerOperationsView/schedulerOperationsView';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import SchedulerAnalyticModeContainer from './SchedulerAnalyticModePanel/SchedulerAnalyticModeContainer';
import Collapse from 'infrastructure/js/components/Collapse/Collapse';
import PermissionManager from 'infrastructure/js/utils/permissionManager';
import ErrorBoundary from '../../ErrorBoundary/errorBoundary'

require('./schedulerPage.scss');

export default class SchedulerPage extends Component {
  constructor(props) {
    super(props);
    this.analyticModeLabels = createLabelHelper('mat.scheduler.analyticMode.');
    this.scrollToNowOnInit = true;

    this.state = {
      analyticModeCollapsed: false,
      errorBoundaryKey: 0,
    };
  }

  componentDidMount() {
    this.props.actions.init(true);
  }

  componentWillUnmount() {
    this.props.actions.unmount();
  }

  setSchedulerEngineInstance = (scheduler) => {
    this.scheduler = scheduler;

    if (this.scrollToNowOnInit && scheduler) {
      this.props.actions.scrollToNow(scheduler);
      this.scrollToNowOnInit = false;
    }
  };

  getSchedulerEngineInstance = () => {
    return this.scheduler;
  };

  getSchedulerData() {
    let schedulerData = this.props.sData.get('schedulerData');
    if (!schedulerData) {
      return null;
    }

    const eventsInDependencyLinesPath = new Set();

    let selectedWos = [
      ...new Set(
        this.props.sData.get('selectedGanttTasks').map((selectedTask) => {
          return selectedTask.wo ? selectedTask.wo.id : null;
        })
      ),
    ];

    schedulerData.selectedDependencies = schedulerData.dependencies.map((dependency) => {
      const isDependencyVisible = selectedWos.some((selectedWo) => dependency.relatedWos.includes(selectedWo));

      if (isDependencyVisible) {
        const { from, to } = dependency;
        eventsInDependencyLinesPath.add(from);
        eventsInDependencyLinesPath.add(to);
      }

      return {
        ...dependency,
        cls: isDependencyVisible ? 'visible-dependency' : 'hidden-dependency',
      };
    });

    return schedulerData;
  }

  getLoadingOverlay() {
    if (!this.props.sData.get('loading')) {
      return null;
    }
    return <Overlay.Loading />;
  }

  renderSchedulerAnalyticMode = () => {
    if (PermissionManager.hasSchedulerAnalyticModePermissions()) {
      return (
        <>
          <Collapse title={this.analyticModeLabels.get('collapseTitle')} onCollapseChange={this.handleCollapseChange}>
            <SchedulerAnalyticModeContainer />
          </Collapse>
          <div className="panel-divider"></div>
        </>
      );
    }
    return null;
  };

  handleCollapseChange = (collapseState) => {
    this.setState({ analyticModeCollapsed: collapseState });
  };

  render() {
    return (
      <div className="scheduler-page">
        <div className="scheduler-gantt-wrapper">
          <ErrorBoundary>
            <Scheduler
              setSchedulerEngineInstance={this.setSchedulerEngineInstance}
              data={this.getSchedulerData()}
              asyncSchedulingData={this.props.sData.get('asyncScheduling')}
              actions={this.props.actions.schedulerGanttActions}
              refreshPage={this.props.actions.refreshPageData}
              loading={this.props.sData.get('loading')}
              selectedTasks={this.props.sData.get('selectedGanttTasks')}
              onEventChange={this.props.actions.schedulerGanttActions.onEventChange}
              onTaskMove={this.props.actions.schedulerGanttActions.onTaskMove}
              onTaskDelete={this.props.actions.schedulerGanttActions.onTaskDelete}
              onSelectionChanged={this.props.actions.schedulerGanttActions.onSelectionChanged}
              onTaskDrop={this.props.actions.schedulerGanttActions.onTaskDrop}
              onTaskLock={this.props.actions.schedulerGanttActions.onTaskLock}
              onTaskUnlock={this.props.actions.schedulerGanttActions.onTaskUnlock}
              reportTaskProgressDialogActions={this.props.actions.reportTaskProgressDialogActions}
              sReportTaskProgressDialogData={this.props.sReportTaskProgressDialogData}
              backtrackList={this.props.sData.get('backtrackList')}
            />
          </ErrorBoundary>
          {this.getLoadingOverlay()}
        </div>

        <div className="scheduler-grid-wrapper">
          {this.renderSchedulerAnalyticMode()}

          <SchedulerOperationsView
            actions={this.props.actions}
            sSelectedRowsData={this.props.sSelectedRowsData}
            sScheduleTaskDialogData={this.props.sScheduleTaskDialogData}
            sAutoSchedulerDialogData={this.props.sAutoSchedulerDialogData}
            sCreateTaskDialogData={this.props.sCreateTaskDialogData}
            sEditTaskAttributesData={this.props.sEditTaskAttributesData}
            sHasRows={this.props.sHasRows}
            sCounters={this.props.sData.get('counters')}
            sSchedulerEngineInstance={this.getSchedulerEngineInstance()}
            sSchedulerData={this.props.sData.get('schedulerData')}
            asyncSchedulingData={this.props.sData.get('asyncScheduling')}
          />
        </div>
      </div>
    );
  }
}

SchedulerPage.propTypes = {
  actions: PropTypes.object.isRequired,
  sData: PropTypes.object,
};

SchedulerPage.defaultProps = {
  sData: {},
};
